import { Grid, Typography } from '@rbx/ui';
import SimpleCodeSnippet from '@modules/ui/codeBlock/CodeBlock';
import { useTranslation } from '@rbx/intl';
import React, { FunctionComponent } from 'react';
import CodeSample from '@modules/utilities/interfaces/CodeSample';
import StandardMarkdown from '@modules/ui/markdown/components/StandardMarkdown';
import useCodeSamplesStyles from './CodeSamples.styles';

export interface CodeSamplesProps {
  codeSamples: CodeSample[];
  typographyId?: string;
}

const CodeSamples: FunctionComponent<React.PropsWithChildren<CodeSamplesProps>> = ({
  codeSamples,
  typographyId,
}) => {
  const { translate } = useTranslation();
  const {
    classes: { outerContainer },
  } = useCodeSamplesStyles();
  const codSampleWithUniqIdentifier = codeSamples.map((item, index) => ({
    ...item,
    identifier: `${item.identifier}=${index}`,
  }));

  return (
    <Grid className={outerContainer}>
      <Typography variant='h4' component='h4' id={typographyId ?? ''}>
        {translate('Label.CodeSamples')}
      </Typography>
      {codSampleWithUniqIdentifier?.map(({ identifier, codeSample, displayName, description }) => {
        return (
          <Grid key={displayName}>
            {description && <StandardMarkdown>{description}</StandardMarkdown>}
            <SimpleCodeSnippet
              key={identifier}
              title={displayName ?? ''}
              enableExpand
              enableCopy
              content={codeSample ?? ''}
              fullWidth
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default CodeSamples;
